import { apiClient } from '../utils/api';
import { UrlBuilder } from '../utils/urls';
import { Subscription, Plan } from '../models';

export interface ApiResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
  code?: number;
}

export interface SubscribeData {
  plan_id: number;
  payment_method: string;
  payment_details?: any;
}

class SubscriptionService {
  // Get user's subscription with token
  async getUserSubscription(token: string, userId: number): Promise<ApiResponse<Subscription>> {
    try {
      const response = await apiClient.getWithToken<Subscription>(
        UrlBuilder.subscriptions.userSubscription(userId),
        token
      );

      if (response.success) {
        return {
          success: true,
          data: response.data
        };
      } else {
        return {
          success: false,
          error: response.error,
          code: response.code
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'An unexpected error occurred'
      };
    }
  }

  // Get all available plans/features (no token needed)
  async getFeatures(): Promise<ApiResponse<Plan[]>> {
    try {
      const response = await apiClient.get<Plan[]>(
        UrlBuilder.subscriptions.features()
      );

      if (response.success) {
        return {
          success: true,
          data: response.data
        };
      } else {
        return {
          success: false,
          error: response.error,
          code: response.code
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'An unexpected error occurred'
      };
    }
  }

  // Subscribe to a plan with token
  async subscribe(token: string, data: SubscribeData): Promise<ApiResponse<Subscription>> {
    try {
      const response = await apiClient.postWithToken<Subscription>(
        UrlBuilder.subscriptions.subscribe(),
        token,
        data
      );

      if (response.success) {
        return {
          success: true,
          data: response.data
        };
      } else {
        return {
          success: false,
          error: response.error,
          code: response.code
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'An unexpected error occurred'
      };
    }
  }

  // Get all subscriptions (admin function) with token
  async getAllSubscriptions(token: string): Promise<ApiResponse<Subscription[]>> {
    try {
      const response = await apiClient.getWithToken<Subscription[]>(
        UrlBuilder.subscriptions.find(),
        token
      );

      if (response.success) {
        return {
          success: true,
          data: response.data
        };
      } else {
        return {
          success: false,
          error: response.error,
          code: response.code
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'An unexpected error occurred'
      };
    }
  }
}

export const subscriptionService = new SubscriptionService();